import React from 'react';
import { twMerge } from 'tailwind-merge';

interface PageHeaderProps {
  children: React.ReactNode;
  className?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  children,
  className = '',
}) => (
  <div
    className={twMerge(
      'bg-gradient-to-r from-sky-50 to-white rounded-lg px-4 py-3',
      className
    )}
  >
    {children}
  </div>
);

export default PageHeader;
